import Router from "@/router/index.js";
export default {
  data() {
    return {
      navColor: "primary",
      // Default color for navbar
      showReturnButton: false // Controls the display of the "Retour" button
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        // Dynamically control "Retour" button visibility
        this.showReturnButton = this.$route.path !== "/Menu" && this.$route.path !== "/";
      }
    }
  },
  methods: {
    goToMenu() {
      Router.push("/Menu");
    }
  }
};